export default "__VITE_ASSET__Dvw44q7z__"